import { jsonGet } from "../api";

/**
 * Check if the user has Google Search Console connected
 */
export const fetchGscStatus = async () => 
  jsonGet("/google-search-console/status");

/**
 * Fetch all verified sites from Google Search Console
 */
export const fetchGscSites = async () => 
  jsonGet("/google-search-console/sites");
